import React, { useEffect, useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import QRCode from 'react-qr-code'

import DispatcherService from '../../services/DispatcherService'

import View from '../form/View'
import Footer from '../form/Footer'
import Loader from '../form/Loader'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1
  },
  title: {
    justifyContent: 'center',
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '36px',
    color: theme.colors.primary,
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    color: theme.colors.secondary,
    marginBottom: '15px'
  },
  qrCode: {
    marginTop: '30px',
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 36px'
  }
}))

function FinishStep (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })

  const [ qrCode, setQrCode ] = useState(null)
  const [ fetching, setFetching ] = useState(true)
  const [ error, setError ] = useState(false)

  const { next, data } = props

  useEffect(() => {
    let timer = null
    let isMounted = true

    const register = async () => {
      try {
        const result = await DispatcherService.finalize(data)
        setQrCode(result?.access?.qrCode)
      } catch (err) {
        console.error(err)
        if (isMounted) {
          setError(err)
        }
      }
      setFetching(false)

      const reload = DispatcherService.shouldReload()
      const reloadTimeout = DispatcherService.getReloadTimeout()
      if (isMounted && reload) {
        timer = setTimeout(next, reloadTimeout)
      }
    }

    register()
    return () => {
      clearTimeout(timer)
      isMounted = false
    }
  }, [])

  if (fetching) {
    return (
      <View className={styles.root}>
        <View className={styles.content}>
          <Loader message="Aguarde, estamos realizando o seu cadastro!" />
        </View>
        <Footer />
      </View>
    )
  }

  return (
    <View className={styles.root}>
      <View className={styles.content}>
        { error ? (
          <>
            <View className={styles.title}>Ocorreu um erro inesperado! =(</View>
            <View className={styles.subtitle}>Entre em contato com o administrador do sistema ou tente novamente.</View>
          </>
        ) : (
          <>
            <View className={styles.title}>
              {props.msg}
            </View>
            { qrCode &&
              <View className={styles.qrCode}>
                <QRCode value={qrCode} />
              </View>
            }
          </>
        )}
      </View>
      <Footer 
        onNext={DispatcherService.shouldReload() && next}
        nextLabel='Fechar'
      />
    </View>
  )
}

export default FinishStep